module.exports = __webpack_public_path__ + "static/img/10.4158bee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/9/10.png
// module id = mv+E
// module chunks = 2